import { Nilable } from "../shared/utils/Nullable";
import "../shared/extensiones/MapExtension";

export interface IBigmlFilesDTO {
    project_id: Nilable<number>;
    project: Nilable<number>;
    projects: Nilable<number[]>;
    deleted_projects: Nilable<number[]>;
    non_deleted_projects: Nilable<number[]>;
    train_vector_questions: Nilable<number[]>;
    predict_vector_questions: Nilable<number[]>;
    project_resource: Nilable<string>;
    train_name: Nilable<string>;
    train_resource: Nilable<string>;
    train_dataset_resource: Nilable<string>;
    train_dataset_id: Nilable<number>;
    predict_name: Nilable<string>;
    predict_resource: Nilable<string>;
    predict_dataset_resource: Nilable<string>;
    predict_dataset_id: Nilable<number>;
    train_columns: Nilable<string[]>;
    predict_columns: Nilable<string[]>;
    fields_ids: Nilable<number[]>;
    dataset_id: Nilable<number>;
    dataset_resource: Nilable<string>;
    message: Nilable<string>;
    available_tasks: Nilable<number>;
    with_tags: Nilable<boolean>;
    classes: Nilable<Map<string, string[]>>;
}

export class BigmlFilesDTO {
    public projectId = 0;
    public projects: number[] = [];
    public deletedProjects: number[] = [];
    public nonDeletedProjects: number[] = [];
    public trainVectorQuestions: number[] = [];
    public predictVectorQuestions: number[] = [];
    public projectResource = "";
    public trainName = "";
    public trainResource = "";
    public trainDatasetResource = "";
    public trainDatasetId = 0;
    public predictName = "";
    public predictResource = "";
    public predictDatasetResource = "";
    public predictDatasetId = 0;
    public trainColumns: string[] = [];
    public predictColumns: string[] = [];
    public fieldsIds: number[] = [];
    public datasetId = 0;
    public datasetResource = "";
    public message = "";
    public availableTasks = 0;
    public withTags = false;
    public classes: Map<string, string[]> = new Map<string, string[]>();

    constructor(json: Nilable<Partial<IBigmlFilesDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlFilesDTO>) {
        if (json.project_id != null) {
            this.projectId = json.project_id;
        }
        if (json.projects != null) {
            this.projects = json.projects;
        }
        if (json.deleted_projects != null) {
            this.deletedProjects = json.deleted_projects;
        }
        if (json.non_deleted_projects != null) {
            this.nonDeletedProjects = json.non_deleted_projects;
        }
        if (json.train_vector_questions != null) {
            this.trainVectorQuestions = json.train_vector_questions;
        }
        if (json.predict_vector_questions != null) {
            this.predictVectorQuestions = json.predict_vector_questions;
        }
        if (json.project_resource != null) {
            this.projectResource = json.project_resource;
        }
        if (json.train_name != null) {
            this.trainName = json.train_name;
        }
        if (json.train_resource != null) {
            this.trainResource = json.train_resource;
        }
        if (json.train_dataset_resource != null) {
            this.trainDatasetResource = json.train_dataset_resource;
        }
        if (json.train_dataset_id != null) {
            this.trainDatasetId = json.train_dataset_id;
        }
        if (json.predict_name != null) {
            this.predictName = json.predict_name;
        }
        if (json.predict_resource != null) {
            this.predictResource = json.predict_resource;
        }
        if (json.predict_dataset_resource != null) {
            this.predictDatasetResource = json.predict_dataset_resource;
        }
        if (json.predict_dataset_id != null) {
            this.predictDatasetId = json.predict_dataset_id;
        }
        if (json.train_columns != null) {
            this.trainColumns = json.train_columns;
        }
        if (json.predict_columns != null) {
            this.predictColumns = json.predict_columns;
        }
        if (json.fields_ids != null) {
            this.fieldsIds = json.fields_ids;
        }
        if (json.dataset_id != null) {
            this.datasetId = json.dataset_id;
        }
        if (json.dataset_resource != null) {
            this.datasetResource = json.dataset_resource;
        }
        if (json.message != null) {
            this.message = json.message;
        }
        if (json.available_tasks != null) {
            this.availableTasks = json.available_tasks;
        }
        if (json.with_tags != null) {
            this.withTags = json.with_tags;
        }
    }

    public toJSON(): IBigmlFilesDTO {
        return {
            project_id: this.projectId,
            project: this.projectId,
            projects: this.projects,
            deleted_projects: this.deletedProjects,
            non_deleted_projects: this.nonDeletedProjects,
            train_vector_questions: this.trainVectorQuestions,
            predict_vector_questions: this.predictVectorQuestions,
            project_resource: this.projectResource,
            train_name: this.trainName,
            train_resource: this.trainResource,
            train_dataset_resource: this.trainDatasetResource,
            train_dataset_id: this.trainDatasetId,
            predict_name: this.predictName,
            predict_resource: this.predictResource,
            predict_dataset_resource: this.predictDatasetResource,
            predict_dataset_id: this.predictDatasetId,
            train_columns: this.trainColumns,
            predict_columns: this.predictColumns,
            fields_ids: this.fieldsIds,
            dataset_id: this.datasetId,
            dataset_resource: this.datasetResource,
            message: this.message,
            with_tags: this.withTags,
            available_tasks: null,
            classes: this.classes.objeto()
        };
    }
}
